/**
 * 햅틱(진동) 피드백 모듈
 *
 * 사용자의 동작에 물리적 피드백을 제공합니다.
 * - 저장 성공 시: 중간 강도의 진동 (Impact Medium)
 * - 삭제 등 파괴적 동작: 강한 진동 (Impact Heavy)
 * - AI 메시지 도착 / 즐겨찾기: 성공 알림 진동 (Notification Success)
 * - 오류 발생 시: 경고 진동 (Notification Warning)
 *
 * 웹 환경에서는 아무 동작 없이 안전하게 무시됩니다.
 */

import { Capacitor } from '@capacitor/core';
import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';

/**
 * 저장 성공 시 호출합니다.
 * 중간 강도의 진동으로 "무언가가 완료됐다"는 느낌을 줍니다.
 */
export async function triggerSaveHaptic() {
  if (!Capacitor.isNativePlatform()) return;

  try {
    await Haptics.impact({ style: ImpactStyle.Medium });
  } catch (err) {
    console.warn('[햅틱] triggerSaveHaptic 실패:', err);
  }
}

/**
 * 탭/버튼 클릭 시 호출합니다.
 * 약한 진동으로 "눌렸다"는 터치 피드백을 줍니다.
 * FNB(하단 탭바) 버튼 등 UI 인터랙션에 사용합니다.
 */
export async function triggerTapHaptic() {
  if (!Capacitor.isNativePlatform()) return;

  try {
    await Haptics.impact({ style: ImpactStyle.Light });
  } catch (err) {
    console.warn('[햅틱] triggerTapHaptic 실패:', err);
  }
}

/**
 * 삭제 등 파괴적 동작 직전에 호출합니다.
 * 강한 진동으로 "중요한 동작이 일어난다"는 경각심을 줍니다.
 */
export async function triggerHeavyHaptic() {
  if (!Capacitor.isNativePlatform()) return;

  try {
    await Haptics.impact({ style: ImpactStyle.Heavy });
  } catch (err) {
    console.warn('[햅틱] triggerHeavyHaptic 실패:', err);
  }
}

/**
 * AI 메시지 도착, 즐겨찾기 추가 등 긍정적 이벤트에 호출합니다.
 * 성공 알림 진동으로 "좋은 일이 생겼다"는 느낌을 줍니다.
 */
export async function triggerSuccessHaptic() {
  if (!Capacitor.isNativePlatform()) return;

  try {
    await Haptics.notification({ type: NotificationType.Success });
  } catch (err) {
    console.warn('[햅틱] triggerSuccessHaptic 실패:', err);
  }
}

/**
 * 오류 발생 시 호출합니다.
 * 경고 진동으로 "문제가 생겼다"는 느낌을 줍니다.
 */
export async function triggerErrorHaptic() {
  if (!Capacitor.isNativePlatform()) return;

  try {
    await Haptics.notification({ type: NotificationType.Warning });
  } catch (err) {
    console.warn('[햅틱] triggerErrorHaptic 실패:', err);
  }
}
